function GlassCircle(props) {
  return (
    <div className={`glass-circle-wrapper rounded-full overflow-hidden ${props?.wrapperClasses || ""}`}>
      <div className={`glass-circle-inner-wrapper pb-[100%] ${props?.innerClasses || ""}`} />
    </div>
  );
}
export default GlassCircle;
